const publishingRequests = {
  requestsBreadcrumb: "Requests",
  listBreadcrumb: "Publishing Requests",
  pendingTab: "Pending",
  pendingTabWithCount: "Pending ({count})",
  doneTab: "Done Requests",
  searchPlaceholder: "Event name / Company name",
  companyName: "Company Name",
  eventName: "Event Name",
  requestType: "Request Type",
  feesAmount: "Fees Amount",
  requestDate: "Request Date",
  paymentProof: "Payment Proof",
  requestStatus: "Request Status",
  amountValue: "{amount} SAR",
  types: {
    publish: "Publish",
    upgrade_size: "Crew Size Change",
  },
  statuses: {
    accepted: "Accepted",
    rejected: "Rejected",
    canceled: "Cancelled",
  },
  accept: "Accept",
  reject: "Reject",
  done: "Done",
  filterCompany: "Company",
  filterType: "Request Type",
  filterDate: "Request Date",
  filterStatus: "Request Status",
  showingRange: "Showing {from}-{to} of {total} requests",
  emptyPendingTitle: "No pending requests",
  emptyPendingDescription:
    "New publishing requests from companies will appear here for your review.",
  emptyDoneTitle: "No decided requests yet",
  emptyDoneDescription:
    "Requests appear here once they're accepted, rejected or cancelled.",
  emptyResultsTitle: "No requests found",
  emptyResultsDescription: "No request matches your search or filters.",
  clearFilters: "Clear search and filters",
  summary: {
    company: "Company",
    event: "Event",
    crewFee: "Crew Fee",
    transferEvidence: "Transfer evidence",
    amountDue: "Amount Due",
    crewSize: "Crew Size",
    crewSizeValue: "{size} (up to {max} applicants)",
    crewSizeRangeValue: "{size} ({min} – {max} applicants)",
    differenceToPay: "Difference to Pay",
    changeCrewSize: "Change Crew Size",
    changeCrewSizeValue: "{from} → {to}",
  },
  cancelledTitle: "Request Cancelled",
  cancelledMessage:
    "The company cancelled this request, so it can no longer be accepted or rejected.",
  rejectDescription: "Reason is mandatory, will be emailed to the company",
  rejectionReason: "Rejection Reason",
  rejectionReasonPlaceholder: "Describing why you are rejecting this request...",
  rejectionReasonRequired: "Rejection reason is required",
  publish: {
    acceptTitle: "Publishing Request",
    acceptDescription: "This will publish the event and charge the Crew Fee.",
    rejectTitle: "Reject Publishing Request",
    acceptedTitle: "Event Published",
    acceptedMessage: "Event is now live. Payment recorded",
    rejectedToast: "Publishing request rejected.",
  },
  upgrade_size: {
    acceptTitle: "Crew Size Change Request",
    acceptDescription: "This will apply the new crew size and charge the difference.",
    rejectTitle: "Reject Crew Size Change Request",
    acceptedTitle: "Crew Size Upgraded",
    acceptedMessage: "Event is now on the {size} crew size.",
    rejectedToast: "Upgrade request rejected.",
  },
};

export default publishingRequests;
